import React, { Fragment, useState, useEffect } from 'react';
import CustomTable from '@jumbo/components/CustomTable';
import PageLoader from '@jumbo/components/custom/Spinner/pageLoader';
import { Visibility, CloudUpload, Bookmark } from '@material-ui/icons';
import VerReclamo from '../VerReclamo';
import AddAntecedente from '../AddAntecedente';
import AddRecurso from '../AddRecurso';
import GetReclamo from '../GetReclamo';
import { API_EXTRANET } from 'config/config';
import { validacionPermit } from '../../../../../services/service.user';
import axios from 'axios';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import Spinner from '@jumbo/components/custom/Spinner';

const headCells = [
  {
    id: 'n_reclamo',
    numeric: false,
    disablePadding: false,
    align: 'left',
    alignContent: 'left',
    label: 'N° Reclamo',
  },
  { id: 'fechaIngreso', alignContent: 'left', label: 'Fecha Ingreso' },
  { id: 'tipo', alignContent: 'left', label: 'Tipo' },
  { id: 'nombre_rec', alignContent: 'left', label: 'Reclamante' },
  { id: 'run_pac', alignContent: 'left', label: 'Rut' },
  { id: 'etapa_actual', alignContent: 'left', label: 'Etapa' },
];

const actions = [
  { action: 'ver', label: 'Ver', icon: <Visibility /> },
  { action: 'addAnt', label: 'Antecedentes', icon: <CloudUpload /> },
  { action: 'addRec', label: 'Recursos', icon: <CloudUpload /> },
  { action: 'autoAsignar', label: 'Autoasignar', icon: <Bookmark /> },
];

const TablaReclamosTodos = () => {
  const [primeraCarga, setPrimeraCarga] = useState(false);
  const [entidadesList, setEntidadesList] = useState([]);
  const [tiposList, setTiposList] = useState([]);
  const [showVerReclamo, setShowVerReclamo] = useState(false);
  const [reclamoVer, setReclamoVer] = useState(null);
  const [showAddAnt, setShowAddAnt] = useState(false);
  const [reclamoAddAnt, setrReclamoAddAnt] = useState(null);
  const [showAddRec, setShowAddRec] = useState(false);
  const [reclamoAddRec, setrReclamoAddRec] = useState(null);
  const [validaciones, setValidaciones] = useState([]);
  const [showAutoAsignarReclamo, setShowAutoAsignarReclamo] = useState(false);
  const [reclamoAutoAsignar, setReclamoAutoAsignar] = useState(null);
  const [spinner, setSpinner] = useState(false);

  const loadEntidades = () => {
    /*  const user = JSON.parse(sessionStorage.getItem('user')); */

    axios
      .get(
        /*         `${API_EXTRANET}api/v1/reclaim_ip?entidad=${user.organization.name}` +
          ' y Servicios Médicos S.A.&indice=mediaciones', */
        `${API_EXTRANET}api/v1/reclaim_ip?entidad=Clínica Dávila y Servicios Médicos S.A.&indice=mediaciones`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
          },
        },
      )
      .then(res => {
        setEntidadesList(
          res.data.map(entidad => {
            return {
              ...entidad,
              fechaIngreso: entidad.fecha_ingreso.split('/').join('-'),
            };
          }),
        );
        setSpinner(false);
        setPrimeraCarga(true);
      })
      .catch(err => {
        setSpinner(false);
        console.log(err);
        toast.error('Ocurrió un error al buscar reclamos.');
      });
  };

  useEffect(() => {
    /* const user = JSON.parse(sessionStorage.getItem('user')); */
    axios
      .get(`${API_EXTRANET}api/v1/etapas_ip`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
        },
      })
      .then(res => {
        setTiposList(res.data);
        loadEntidades();
      })
      .catch(err => {
        toast.error('Ocurrió un error al cargar el filtro de etapas.');
        console.log(err);
      });
  }, []);

  useEffect(() => {
    var auxValidaciones = [
      {
        type: 'dateRange',
        target: 'fechaIngreso',
        title: 'Fecha',
      },
    ];

    if (tiposList.length) {
      var tipos = tiposList.map(item => {
        return item.etapa;
      });
      const item = {
        type: 'select',
        target: 'etapa_actual',
        title: 'Tipo',
        options: tipos,
      };
      auxValidaciones.push(item);
    }
    setValidaciones(auxValidaciones);
  }, [tiposList]);

  const handleAction = (menu, item) => {
    if (menu.action === 'ver') {
      setReclamoVer(item);
      setShowVerReclamo(true);
    } else if (menu.action === 'addAnt') {
      setrReclamoAddAnt(item);
      setShowAddAnt(true);
    } else if (menu.action === 'addRec') {
      setrReclamoAddRec(item);
      setShowAddRec(true);
    } else if (menu.action === 'autoAsignar') {
      setReclamoAutoAsignar(item);
      setShowAutoAsignarReclamo(true);
    }
  };

  const verReclamoClose = () => {
    setShowVerReclamo(false);
    setReclamoVer(null);
  };

  const AddAntClose = () => {
    setrReclamoAddAnt(null);
    setShowAddAnt(false);
  };

  const AddRecClose = () => {
    setrReclamoAddRec(null);
    setShowAddRec(false);
  };

  const autoAsignarReclamoSubmit = () => {
    setShowAutoAsignarReclamo(false);
    setReclamoAutoAsignar(null);
    setSpinner(true);
    loadEntidades();
  };

  const autoAsignarReclamoClose = () => {
    setShowAutoAsignarReclamo(false);
    setReclamoAutoAsignar(null);
  };

  return (
    validacionPermit('search_reclaim_ip') && (
      <Fragment>
        <Spinner show={spinner} />
        <CustomToast />
        <VerReclamo openDialog={showVerReclamo} close={verReclamoClose} reclamo={reclamoVer} />
        <AddAntecedente openDialog={showAddAnt} close={AddAntClose} reclamo={reclamoAddAnt} />
        <AddRecurso openDialog={showAddRec} close={AddRecClose} reclamo={reclamoAddRec} />
        <GetReclamo
          openDialog={showAutoAsignarReclamo}
          close={autoAsignarReclamoClose}
          reclamo={reclamoAutoAsignar}
          submit={autoAsignarReclamoSubmit}
        />

        {primeraCarga ? (
          entidadesList.length === 0 ? (
            <h1>No hay reclamos</h1>
          ) : (
            <CustomTable
              headCells={headCells}
              rows={entidadesList}
              title={'Reclamos'}
              validation={validaciones}
              search={true}
              actions={actions}
              handleAction={handleAction}
            />
          )
        ) : (
          <PageLoader />
        )}
      </Fragment>
    )
  );
};

export default TablaReclamosTodos;
